const HeatMap = {
    chart: {
        type: 'heatmap',
        minWidth: "100%!important",
        backgroundColor: '#F5F5F5',
        plotBorderColor: "#FFFFFF",
        borderColor: '#F5F5F5',
        borderRadius: 8,
        marginTop:60,
    },
    title: {
        text: 'Weekday and hour accidents plot',
        align: 'left',
        style: {
            fontFamily: 'Stolzl-Medium',
            fontStyle: 'normal',
            color: '#282B2D',
            textDecoration: 'none',
            fontSize: '14px',
            fontWeight: '500',
            lineHeight: 18,
            whiteSpace:'nowrap'
        }
    },
    exporting: {
        enabled: false
    },
    xAxis: {
        gridLineWidth: 0,
        categories: ['', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        opposite: true,
        labels: {
            align: 'center',
            useHTML: true,
            style: {
                fontStyle: 'normal',
                fontSize: "8px",
                fontFamily: 'Poppins',
                fontWeight: '500',
                lineHeight: "12px",
                color: '#808080',
            }
        }
    },
    tooltip: {
        enabled: false
    },
    credits: {
        enabled: false
    },
    yAxis: {
        categories: ['', '6:00',
            '7:00',
            '8:00',
            '9:00',
            '10:00',
            '11:00',
            '12:00',
            '13:00',
            '14:00',
            '15:00',
            '16:00',
            '17:00',
            '18:00',
            '19:00',
            '20:00',
            '21:00',
            '22:00',
            '23:00',
            '0:00'],
        title: null,
        reversed: true,
        inside: true,
        gridLineWidth: 0,
        borderWidth: 1,
        labels: {
            // distance: '75%',
            // y: 5
            // x:29,
            style: {
                // position: "relative",
                // left: "50% !important",
                // transform: "translateX(-50%)",
                fontStyle: 'normal',
                fontSize: "8px",
                fontFamily: 'Poppins',
                fontWeight: '500',
                lineHeight: "12px",
                color: '#808080',
            }
        }
    },
    colorAxis: {
        min: 0,
        minColor: '#FFFFFF',
        // maxColor: Highcharts.getOptions().colors[0]
        maxColor: '#FE3939'
    },
    legend: {
        enabled: false,
    },
    series: [{
        borderWidth: 1,
        // animation: false,
        color: '#FFFFFF',
        data: [[0, 0, 0], [0, 1, 0], [0, 2, 0], [0, 3, 0], [0, 4, 0], [0, 5, 0], [0, 6, 0], [0, 7, 0], [1, 0, 0], [2, 0, 0], [3, 0, 0], [4, 0, 0], [5, 0, 0], [6, 0, 0], [7, 0, 0], [8, 0, 0], [9, 0, 0], [10, 0, 0], [11, 0, 0], [12, 0, 0], [13, 0, 0], [14, 0, 0], [15, 0, 0], [16, 0, 0], [17, 0, 0], [18, 0, 0], [19, 0, 0], [7, 1, 19], [7, 2, 8], [7, 3, 24], [7, 4, 67], [7, 7, 92], [7, 1, 58], [1, 2, 78], [1, 3, 117], [1, 4, 48], [2, 7, 35], [2, 1, 15], [2, 2, 123], [2, 3, 64], [2, 4, 52], [3, 7, 72], [3, 1, 132], [3, 2, 114], [3, 3, 19], [3, 4, 16], [4, 7, 38], [4, 1, 5], [4, 2, 8], [4, 3, 117], [4, 4, 115], [5, 7, 88], [5, 1, 32], [5, 2, 12], [5, 3, 6], [5, 4, 120], [6, 7, 13], [6, 1, 44], [6, 2, 88], [6, 3, 98], [6, 4, 96], [7, 7, 31], [7, 1, 1], [7, 2, 82], [7, 3, 32], [7, 4, 30], [8, 7, 85], [8, 1, 97], [8, 2, 123], [8, 3, 64], [8, 4, 84], [9, 7, 47], [9, 1, 114], [9, 2, 31], [9, 3, 48], [9, 4, 91],
            [6, 5, 10], [7, 7, 10], [6, 6, 190], [7, 5, 10], [6, 6, 10], [7, 7, 10], [8, 1, 19], [9, 2, 8], [10, 3, 24], [11, 4, 67], [12, 7, 92], [1, 1, 0], [10, 1, 0], [11, 1, 0], [12, 1, 0], [13, 1, 0], [14, 1, 0], [15, 1, 0], [16, 1, 0], [17, 1, 0], [18, 1, 0], [19, 1, 0],
            [10, 2, 0], [11, 2, 0], [12, 2, 0], [13, 2, 0], [14, 2, 0], [15, 2, 0], [16, 2, 0], [17, 2, 0], [18, 2, 0], [19, 2, 50],
            [10, 2, 0], [11, 3, 0], [12, 3, 0], [13, 3, 0], [14, 3, 0], [15, 3, 0], [16, 3, 0], [17, 3, 0], [18, 3, 0], [19, 3, 100],
            [10, 4, 0], [11, 4, 0], [12, 4, 0], [13, 4, 0], [14, 4, 0], [15, 4, 0], [16, 4, 0], [17, 4, 0], [18, 4, 0], [19, 4, 50],
            [1, 5, 0], [2, 5, 0], [3, 5, 0], [4, 5, 0], [5, 5, 0], [8, 5, 0], [9, 5, 0], [10, 5, 0], [11, 5, 0], [12, 5, 0], [13, 5, 0], [14, 5, 0], [15, 5, 0], [16, 5, 0], [17, 5, 0], [18, 5, 0], [19, 5, 100],
            [1, 6, 0], [2, 6, 0], [3, 6, 0], [4, 6, 0], [5, 6, 0], [6, 6, 0], [7, 6, 0], [8, 6, 0], [9, 6, 0], [10, 6, 0], [11, 6, 0], [12, 6, 0], [13, 6, 0], [14, 6, 0], [15, 6, 0], [16, 6, 0], [17, 6, 0], [18, 6, 0], [19, 6, 100],
            [1, 7, 0], [2, 7, 0], [3, 7, 0], [4, 7, 0], [5, 7, 0], [6, 7, 0], [7, 7, 0], [8, 7, 0], [9, 7, 0], [10, 7, 0], [11, 7, 0], [12, 7, 0], [13, 7, 0], [14, 7, 0], [15, 7, 0], [16, 7, 0], [17, 7, 0], [18, 7, 0], [19, 7, 100],
        ],
    }],
}
export default HeatMap;
